import React , { useState, useEffect} from 'react';
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import { useUser } from '../../Hooks/useUser';
import InputMask from 'react-input-mask';
import axios from '../../api/axios';
import { useFormData } from "../../Hooks/useFormDataContext";


const Church = (props) =>{
 const { enqueueSnackbar } = useSnackbar();
  const endpoint = '/api/users/alluserinfo';
  const { user: contextUser } = useUser();

  // True when the parent is explicitly passing User/UserSettings (even if still null while loading)
  const isControlled = Object.prototype.hasOwnProperty.call(props, 'User');

  const [User, setUser] = useState(props.User ?? {});
  const [UserSettings, setUserSettings] = useState(props.UserSettings ?? {});
  const [saving, setSaving] = useState(false);
  const { updateForm } = useFormData();

  // Sync local state whenever the parent's data arrives/changes
  useEffect(() => {
    if (isControlled && props.User) setUser(props.User);
  }, [isControlled, props.User]);

  useEffect(() => {
    if (isControlled && props.UserSettings) setUserSettings(props.UserSettings);
  }, [isControlled, props.UserSettings]);

  // Only fetch our own copy when nobody above us is supplying the data
  useEffect(() => {
    if (isControlled) return;

    const targetUserId = contextUser?.UserID;
    if (!targetUserId) return;

    const fetchData = async () => {
      try {
        const result = await axios.get(`${endpoint}/${targetUserId}`);
        setUserSettings(result.data.userSettings);
        setUser(result.data.user);
      } catch (error) {
        console.error('Church fetch failed:', error);
        enqueueSnackbar('Failed to load church information', { variant: 'error' });
      }
    };

    fetchData();
  }, [isControlled, contextUser?.UserID]);

  function handleCheckboxChange(input) {
    const target = input.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;
    setUserSettings({ ...UserSettings, [name]: value ? 1 : 0 });
    if (props.UseFormContext) {
      updateForm("UserSettings", name, value ? 1 : 0);
    }
  }

  function handleFieldChange(input) {
    const target = input.target;
    const value = target.value;
    const name = target.id;
    setUserSettings({ ...UserSettings, [name]: value });
    if (props.UseFormContext) {
      updateForm("UserSettings", name, value);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await axios.put(`/api/users/alluserinfo`, { user: User, userSettings: UserSettings });
      //console.log(res);
      enqueueSnackbar("Church Section Saved!");
    } catch (ex) {
      console.error(ex);
      enqueueSnackbar('Failed to save church information', { variant: 'error' });
    } finally {
      setSaving(false);
    }
  };

    return(
      <form onSubmit={handleSubmit}>
        <div id="tab9">
          <div className="row px-5 pt-5">
            <div className="col-md-4">
              <div className="health-selection-wrapper">
                <div className="checkboxes-and-radios">
                  <input type="checkbox" id="BP_C_Baptist" checked={UserSettings.BP_C_Baptist} onChange={handleCheckboxChange}/>
                  <label htmlFor="BP_C_Baptist">I attend a Church:</label>
                </div>
              </div>
            </div>
            { UserSettings.BP_C_Baptist ? 
            <div className='row'>
            <div className="col-md-8"></div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="required-caption">Church Name</label>
                <input type="text" id='BP_C_ChurchName' maxLength="200" className="form-control" placeholder="Enter church name" value={UserSettings.BP_C_ChurchName} onChange={handleFieldChange}/>
                <small className="form-text text-muted">Write the full name of your church (i.e. First Baptist Church or Calvary Baptist Church)</small> </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="required-caption">Church City</label>
                <input type="text" id="BP_C_ChurchCity" maxLength="200" className="form-control" placeholder="Enter church city" value={UserSettings.BP_C_ChurchCity} onChange={handleFieldChange}/>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label id="" className="required-caption" htmlFor="">Church State</label>
                <select name="" id="BP_C_ChurchState" className="DropDownField form-control" value={UserSettings.BP_C_ChurchState} onChange={handleFieldChange}>
                  <option value=""></option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="required-caption">Church Phone</label>
                <InputMask 
                  mask="(999) 999-9999" 
                  value={UserSettings.BP_C_ChurchPhone || ''} 
                  onChange={handleFieldChange}
                >
                  {(inputProps) => (
                    <input 
                      {...inputProps}
                      id='BP_C_ChurchPhone' 
                      type="text" 
                      className="form-control" 
                      placeholder="(123) 456-7890"
                    />
                  )}
                </InputMask>
              </div>
            </div>
            <hr/>
        </div>
        : "" }

        {
          //only show save button if form not used in registration
          !props.UseFormContext ?
          

        <div className="row my-5">
          <div className="col-md-12 text-center"> 
            <a className="button-default" onClick={handleSubmit} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', minHeight: '38px', minWidth: '120px', padding: '8px 20px', opacity: saving ? 0.7 : 1, pointerEvents: saving ? 'none' : 'auto' }}>
              {saving && <CircularProgress size={14} style={{ color: 'white' }} />}
              Save
            </a> 
          </div>
        </div>
          : ""
}
          </div>
        </div>
      </form>
    )
}
export default Church;